export class UserPrivateAuthModel {

  async getSessionData() {
    return await new Promise((resolve, reject) => {
      let data = window.localStorage.getItem('user-data');
      let idcod = window.localStorage.getItem('user-idcod');
      if (data && idcod && data != '[]' && data != '{}') {
        data = JSON.parse(data);
        data.imageURL = APICRUD.Image.GetUrl(data.image, true);
        resolve(data);
      } else {
        APICRUD.Auth.InfoSession()
          .then(info => {
            window.localStorage.setItem('user-data', JSON.stringify(info));
            info.imageURL = APICRUD.Image.GetUrl(info.image, true);
            resolve(info);
          })
          .catch(_error => {
            if (_error && _error != 'KO') {
              reject({ message: _error })
            } else {
              reject({ message: 'Ocurrió un error al intentar guardar sus datos, por favor revise su información e inténtelo nuevamente.' })
            }
          });
      }
    });
  }

  async setSessionData(_data) {
    return await new Promise((resolve, reject) => {
      //#region Guardar usuario
      APICRUD.Auth.UpdateSession(_data)
        .then(_result => {
          if (_result == 'OK') {
            resolve();
          } else {
            if (typeof _result == 'object' || (typeof _result == 'string' && _result.indexOf('{') > -1)) {
              _result = JSON.parse(_result);
              reject(_result)
            } else {
              reject({ message: _result })
            }
          }
        })
        .catch(_error => {
          if (_error && _error != 'KO') {
            reject({ message: _error })
          } else {
            reject({ message: 'Ocurrió un error al intentar guardar sus datos, por favor revise su información e inténtelo nuevamente.' })
          }
        });
    });
  }

  async getInfoUserFromIdcod(_idcod) {
    return await new Promise((resolve, reject) => {
      APICRUD.Auth.UserInfo(_idcod)
        .then(resolve)
        .catch(reject)
    });
  }

  register() {
    return new Promise((resolve, reject) => {
      document.getElementById('register-status').setAttribute('style', 'color: red');

      if (document.getElementById('register-email').value.trim() == "") {
        document.getElementById('register-email').focus();
        reject('Debe ingresar su email.');
        return;
      }

      if (document.getElementById('register-pass').value.trim() == "") {
        document.getElementById('register-pass').focus();
        reject('Debe ingresar una contraseña.');
        return;
      }

      if (document.getElementById('register-re-pass').value.trim() != document.getElementById('register-pass').value.trim()) {
        document.getElementById('register-re-pass').focus();
        reject('Las contraseñas no coinciden.');
        return;
      }

      if (document.getElementById('register-name').value.trim() == "") {
        document.getElementById('register-name').focus();
        reject('Debe ingresar su nombre.');
        return;
      }

      if (document.getElementById('register-phone').value.trim() == "") {
        document.getElementById('register-phone').focus();
        reject('Debe ingresar su teléfono.');
        return;
      }

      if (document.getElementById('register-idState').value == '0') {
        document.getElementById('register-idState').focus();
        reject('Debe seleccionar una provincia.');
        return;
      }

      if (document.getElementById('register-idCity').value == '0') {
        document.getElementById('register-idCity').focus();
        reject('Debe seleccionar una localidad.');
        return;
      }

      if (document.getElementById('register-terms').checked == false) {
        reject('Debe aceptar los Términos y Condiciones de uso de nuestro servicio.');
        return;
      }

      let obj = {
        nombre: 'register-name',
        email: 'register-email',
        clave: 'register-pass',
        telefono: 'register-phone',
        ocupacion: 'register-occupation',
        organizacion: 'register-organization',
        localidad: 'register-idCity',
        provincia: 'register-idState',
      };

      document.getElementById('register-status').setAttribute('style', 'color: ihnerit');
      document.getElementById('register-status').innerHTML = 'Registro en curso...';
      document.getElementById('register-btn').classList.add('locked');

      APICRUD.Auth.Register(obj)
        .then((data) => {
          document.getElementById('register-status').innerHTML = 'Registro finalizado.';
          resolve(data);
        })
        .catch(reject);
    });
  }

  activation(_code) {
    return new Promise((resolve, reject) => {
      APICRUD.Auth.Activation(_code)
        .then(resolve)
        .catch(reject);
    });
  }
}
